import { render, staticRenderFns } from "./CveVulnerabilities.vue?vue&type=template&id=3d6a59f5&scoped=true&"
import script from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
import style0 from "./CveVulnerabilities.vue?vue&type=style&index=0&id=3d6a59f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a59f5",
  null
  
)

export default component.exports